<template>
  <base-page-template>
    <v-container fluid>
      <v-card outlined class="elevation-0">
        <v-card-title>
          サービス
          <v-spacer></v-spacer>
          <v-chip
            label dark color="gray darken-4" class="ml-3 px-4"
            v-if="tradeContract.isOtherConsume">
            利用
          </v-chip>
          <v-chip
            label dark color="gray darken-4" class="ml-3 px-4"
            v-if="tradeContract.isOtherProduce">
            提供
          </v-chip>
        </v-card-title>
        <v-card-subtitle>
          <template v-if="tradeContract.selfDataProfileId">
            契約に使用するサービスを選択して下さい
          </template>
          <template v-else>
            <error-icon level="error" small></error-icon>
            はじめにデータステップでマッピングさせるデータプロファイルを選択して下さい。
          </template>
        </v-card-subtitle>
        <v-card-text>
          <v-stepper
            v-model="stepper"
            flat
            vertical>

            <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               Step 1 サービス構成モデル
             - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <v-stepper-step step="1" :complete="!!tradeContract.otherServiceComponentModelId">
              サービス構成モデルの選択
            </v-stepper-step>
            <div v-if="stepper !== 1" class="v-stepper__content">
              <el-table
                :data="otherServiceComponentModel ? [otherServiceComponentModel] : []"
                row-key="id"
                border>
                <el-table-column
                  label="名称"
                  width="200"
                  prop="name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.name"
                        :value-local-id="row.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                  label="説明"
                  prop="description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.description"
                        placeholder="未設定"
                        multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                    justify="center"
                    class="pa-10"
                    v-if="serviceComponentModelsLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>
            </div>
            <v-stepper-content step="1">
              <el-table
                :data="serviceComponentModels"
                row-key="id"
                border>
                <el-table-column
                  label="選択"
                  column-key="selected"
                  width="70"
                  align="center">
                  <template #default="{row}">
                    <table-inline>
                      <el-radio
                        :value="tradeContract.otherServiceComponentModelId === row.id"
                        @change="tradeContract.otherServiceComponentModelId = row.id"
                        :label="true"
                        class="no-label"
                        v-if="editable">
                      </el-radio>
                      <readonly-checkbox
                        :value="tradeContract.otherServiceComponentModelId === row.id"
                        v-else>
                      </readonly-checkbox>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                  label="名称"
                  width="200"
                  prop="localServiceComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.name"
                        :value-local-id="row.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                  label="説明"
                  prop="localServiceComponentModel.description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.description"
                        placeholder="未設定"
                        multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                    justify="center"
                    class="pa-10"
                    v-if="serviceComponentModelsLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>

              <div class="stepper-actions">
                <v-btn
                  color="primary"
                  @click="stepper = 2"
                  :disabled="!tradeContract.otherServiceComponentModelId">
                  次へ
                </v-btn>
              </div>
            </v-stepper-content>

            <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               Step 2 プロセス構成モデル
             - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <v-stepper-step step="2" :complete="!!tradeContract.otherProcessComponentModelId">
              プロセス構成モデルの選択
            </v-stepper-step>
            <v-stepper-content step="2" class="process-profiles">
              <el-table
                :data="processComponentModels"
                row-key="id"
                border>
                <el-table-column
                  label="選択"
                  column-key="selected"
                  width="70"
                  align="center">
                  <template #default="{row}">
                    <table-inline>
                      <el-radio
                        :value="tradeContract.otherProcessComponentModelId === row.id"
                        @change="tradeContract.otherProcessComponentModelId = row.id"
                        :label="true"
                        class="no-label"
                        v-if="editable">
                      </el-radio>
                      <readonly-checkbox
                        :value="tradeContract.otherProcessComponentModelId === row.id"
                        v-else>
                      </readonly-checkbox>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                  label="名称"
                  width="200"
                  prop="name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.name"
                        :value-local-id="row.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                  label="説明"
                  prop="description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                        :value="row.description"
                        placeholder="未設定"
                        multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                    justify="center"
                    class="pa-10"
                    v-if="processComponentModelsLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>

              <div class="stepper-actions">
                <v-btn
                  @click="stepper = 1">
                  戻る
                </v-btn>
                <v-btn
                  color="primary"
                  @click="$emit('next-step')"
                  :disabled="!tradeContract.otherProcessComponentModelId">
                  {{ nextPageName }}に進む
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-container>

    <app-header :errors="errors">
      <error-panel :errors="errors" small></error-panel>
      <v-spacer></v-spacer>
      <v-btn
        elevation="0"
        color="primary"
        style="align-self: center;"
        :disabled="!isCompletable"
        @click="$emit('next-step')">
        {{ nextPageName }}に進む
      </v-btn>
    </app-header>
  </base-page-template>
</template>

<script>
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import {mapActions, mapGetters} from "vuex";
import {emptyTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import BetterSet from "betterset";
import gql from "graphql-tag";
import scrollIntoView from "scroll-into-view-if-needed";

export default {
  name: "CompanionServiceProfile",
  components: {
    ErrorIcon, BasePageTemplate, TextFieldLike,
    AppHeader, ErrorPanel, TableInline, ReadonlyCheckbox},
  props: {
    tradeContracts: {
      type: Array,
      required: true
    },
    tradeContractIndex: {
      type: Number,
      default: 1
    },
    editable: {
      type: Boolean
    },
    steps: {
      type: Array,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      stepper: 0,
      serviceComponentModels: [],
      serviceComponentModelsSourceId: null,
      serviceComponentModelsLoading: false,
      processComponentModels: [],
      processComponentModelsSourceId: null,
      processComponentModelsLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client',
    }),
    tradeContract() {
      return this.tradeContracts[this.tradeContractIndex - 1] ?? emptyTradeContractView();
    },
    otherServiceComponentModel() {
      const otherServiceComponentModelId = this.tradeContract.otherServiceComponentModelId;
      if(otherServiceComponentModelId) {
        return this.serviceComponentModels.find(scm => scm.id === otherServiceComponentModelId);
      } else {
        return null;
      }
    },
    isCompletable() {
      return this.tradeContract.otherServiceComponentModelId &&
        this.tradeContract.otherProcessComponentModelId;
    },
    errors() {
      const errors = [];
      if(!this.tradeContract.selfDataProfileId) {
        const routeBase = this.$route.name.replace(/^(\/[^/]+).*$/, '$1');
        errors.push({
          level: 'error',
          message: [
            'はじめにデータプロファイルを',
            this.$createElement('router-link', {
              props: {
                to: {name: `${routeBase}/dataProfile`}
              }
            }, ['選択']),
            'して下さい。'
          ]
        });
      }
      switch(this.stepper) {
        case 1:
          if(this.tradeContract.otherServiceComponentModelId) {
            errors.push({
              level: 'good',
              message: 'サービス構成モデルが選択されています。「次へ」を押すとプロセス構成モデルの選択に移動します。'
            });
          } else {
            errors.push({
              level: 'info',
              message: 'サービス構成モデルを選択してください。'
            });
          }
          break;
        case 2:
          if(!this.tradeContract.otherProcessComponentModelId) {
            errors.push({
              level: 'info',
              message: 'プロセス構成モデルを選択してください。'
            });
          }
          break;
      }
      return errors;
    },
    nextPageName() {
      return this.steps[this.step + 1]?.label ?? '契約内容';
    },
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    /**
     * Step1
     *
     * @return {Promise<void>}
     */
    async loadServiceComponentModels() {
      const selfDataProfileId = this.tradeContract.selfDataProfileId;
      if(!selfDataProfileId || this.serviceComponentModelsSourceId === selfDataProfileId) {
        return;
      }

      try {
        this.serviceComponentModelsLoading = true;
        this.serviceComponentModels = [];

        const {data: dataProfile} = await this.hcsClient.get(`/data_profiles/${selfDataProfileId}`);
        const dataComponentModelId = dataProfile.dataComponentModelId;

        const {dataComponentModel} = await this.gqlQuery({
          query: gql`
              query FindProcessOperations(
                  $dataComponentModelId: ID!,
              ) {
                  dataComponentModel: dataComponentModel(dataComponentModelId: $dataComponentModelId) {
                      processOperations {
                        operationType
                        processComponentModelId
                        serviceComponentModelId
                      }
                  }
              }`,
          variables: {
            dataComponentModelId: dataComponentModelId
          }
        });

        const serviceComponentModelIds = new BetterSet(dataComponentModel.processOperations.map(po => po.serviceComponentModelId))
        const {serviceComponentModels} = await this.gqlQuery({
          query: gql`
              query FindServiceComponentModel(
                  $serviceComponentModelIds: [ID!]!,
              ) {
                  serviceComponentModels: serviceComponentModelInBulk(serviceComponentModelIds: $serviceComponentModelIds) {
                      id
                      name
                      description
                  }
              }`,
          variables: {
            serviceComponentModelIds: serviceComponentModelIds.asArray(),
          }
        });

        this.serviceComponentModels = serviceComponentModels;
      } finally {
        this.serviceComponentModelsLoading = false;
      }
    },
    /**
     * Step2
     *
     * @return {Promise<void>}
     */
    async loadProcessComponentModels() {
      const otherServiceComponentModelId = this.tradeContract.otherServiceComponentModelId;
      if(!otherServiceComponentModelId || this.processComponentModelsSourceId === otherServiceComponentModelId) {
        this.processComponentModelsLoading = false;
        return;
      }

      try {
        this.processComponentModelsLoading = true;
        this.processComponentModels = [];

        const {serviceComponentModel} = await this.gqlQuery({
          query: gql`
              query FindServiceComponentModel(
                  $serviceComponentModelId: ID!,
              ) {
                  serviceComponentModel: serviceComponentModel(serviceComponentModelId: $serviceComponentModelId) {
                      processComponentModels {
                        id
                        name
                        description
                      }
                  }
              }`,
          variables: {
            serviceComponentModelId: otherServiceComponentModelId,
          }
        });

        this.processComponentModels = serviceComponentModel.processComponentModels;
        this.processProfilesSourceId = otherServiceComponentModelId;
      } finally {
        this.processComponentModelsLoading = false;

        /**
         * 動的にコンテンツが変更されたときに v-stepper-content の高さが更新されない不具合の修正。
         * 450 ミリ秒後に、その時点での高さが再設定されてしまうので
         * 500 ミリ秒後に、高さをリセットします。
         *
         * @see https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VStepper/VStepperContent.ts#L129
         */
        setTimeout(() => {
          const swEl = this.$el.querySelector('.v-stepper__content.process-profiles > .v-stepper__wrapper');
          if(swEl) {
            swEl.style.height = 'auto';
          }
        }, 500);
      }
    },
  },
  watch: {
    stepper: {
      immediate: false,
      async handler(stepper) {
        switch(stepper) {
          case 1:
            this.tradeContract.otherProcessComponentModelId = null;
            await this.loadServiceComponentModels();
            return;
          case 2:
            this.serviceComponentModelsLoading = true;
            this.processComponentModelsLoading = true;
            await this.loadProcessComponentModels();
            await this.loadServiceComponentModels();
            this.$nextTick(() => {
              const el = this.$el.querySelector('.process-profiles');
              scrollIntoView(el, {
                scrollMode: 'if-needed',
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
                skipOverflowHiddenElements: true
              });
            });
            return;
        }
      }
    },
    'tradeContract': {
      immediate: true,
      async handler() {
        if(this.tradeContract.otherProcessComponentModelId) {
          this.stepper = 2;
        } else if(this.tradeContract.selfDataProfileId) {
          this.stepper = 1;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.multipane.layout-v > * {
  min-height: 500px;
}

.empty-service {
  margin-top: 1.5rem;
  font-size: 150%;
}

.empty-event {
  font-size: 150%;
  margin: 2rem -1000px 0;
  line-height: 2;
}

.stepper-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  padding: 3px;
  margin-left: -3px;

  & > * {
    margin-right: 1.5rem;
  }
}
</style>
